export default "__VITE_ASSET__qmZ8p_2z__"